import React, { PureComponent } from 'react';
import { any, bool, func, number, object } from 'prop-types';
import SnackBar from '@material-ui/core/Snackbar';
import styled from 'styled-components';
import { emptyFunction } from '../../core/util/function';
import { colors } from '../../constants/colors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { EMPTY_ARRAY } from '../../core/util/array';

const StyledSnackBar = styled(SnackBar)`
  max-width: 348px;
  margin: auto;
  transform: translateY(-15px);
  div {
    background-color: ${colors.myRightFoot};
    border-radius: 5px;
  }
`;

class SolvSnackBar extends PureComponent {
  static propTypes = {
    action: any,
    anchorOrigin: object,
    autoHideDuration: number,
    canClickToClose: bool,
    classes: object,
    children: any,
    onClose: func,
    open: bool.isRequired,
  };

  static defaultProps = {
    autoHideDuration: 2000,
    onClose: emptyFunction,
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'bottom',
    },
  };

  constructor(props) {
    super(props);

    this.state = { open: !!props.open };
  }

  componentDidUpdate = prevProps => {
    if (!prevProps.open && this.props.open) {
      this.setState({ open: true }); // eslint-disable-line react/no-did-update-set-state
    }

    if (prevProps.open && !this.props.open) {
      this.setState({ open: false }); // eslint-disable-line react/no-did-update-set-state
    }
  };

  getCloseX = () => (
    <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleOnClose}>
      <CloseIcon />
    </IconButton>
  );

  handleOnClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  render = () => {
    const {
      anchorOrigin,
      canClickToClose,
      children,
      classes,
      action,
      autoHideDuration,
    } = this.props;
    const { open } = this.state;
    return (
      <StyledSnackBar
        action={[action, canClickToClose && this.getCloseX()]}
        anchorOrigin={anchorOrigin}
        autoHideDuration={autoHideDuration}
        classes={classes}
        message={children}
        onClose={this.handleOnClose}
        open={open}
      />
    );
  };
}

export default SolvSnackBar;
